import React, { useState, useEffect, useRef } from "react";
import { Card, Spinner } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;

function MyTeamTree() {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState(null);
  const [showTree, setShowTree] = useState(false);
  const treeRef = useRef(null);

  const getAuthToken = () => localStorage.getItem("token");

  const fetchTreeData = async (e) => {
    e.preventDefault();
    if (!mobile) {
      Swal.fire("Missing Input", "Please enter a mobile number", "warning");
      return;
    }

    setLoading(true);
    setTreeData(null);
    setShowTree(false);

    try {
      const token = getAuthToken();
      const response = await axios.get(
        `${API_URL}/myteam-tree?mobile=${mobile}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.status === "1") {
        const formattedTree = {
          name: `${response.data.parent_mobile}`,
          role: "Parent",
          children: buildTreeStructure(response.data.tree || []),
          expanded: false,
        };
        setTreeData(formattedTree);
        setShowTree(true);
      } else {
        Swal.fire("No Data", response.data.message || "No data found", "info");
      }
    } catch (error) {
      console.error("Tree fetch error:", error);
      Swal.fire("Warning !!!", "Sorry No Data Found Please Try Another.", "info");
    } finally {
      setLoading(false);
    }
  };

  const buildTreeStructure = (nodes) =>
    nodes.map((node) => ({
      name: `${node.username} (${node.mobile})`,
      role: node.user_type,
      level: node.level,
      kyc: node.kyc,
      status: node.status,
      date: node.date,
      expanded: false,
      children: buildTreeStructure(node.children || []),
    }));

  const toggleNode = (node) => {
    node.expanded = !node.expanded;
    setTreeData({ ...treeData });
  };

  const renderTree = (node, isRoot = false) => (
    <li key={node.name}>
      <span>
        <strong>{node.name}</strong>
        <br />
        <small className="text-capitalize">Role: {node.role}</small>
        {!isRoot && (
          <>
            <br />
            <small>Level: {node.level}</small>
            {/* <br />
            <small>KYC: {node.kyc}</small>*/}
            {/* <br />  */}

            <br />

            <small>SQYD: {node.buysqrt || "0.00"}</small>
            <br />


            <small>DOR: {node.date}</small>
            <br />
            <small>
              Associate Status :{" "}
              <div className="d-inline text-capitalize"
                style={{
                  color: node.status === "success" ? "green" : "red",
                }}
              >
                {node.status}
              </div>
            </small>
          </>
        )}
        {node.children && node.children.length > 0 && (
          <button
            className="toggle-btn"
            onClick={() => toggleNode(node)}
            title={node.expanded ? "Hide children" : "Show children"}
          >
            {node.expanded ? "−" : "+"}
          </button>
        )}
      </span>

      {node.expanded && node.children?.length > 0 && (
        <ul>{node.children.map((child) => renderTree(child))}</ul>
      )}
    </li>
  );

  // ✅ Center tree only once after it is first shown
  useEffect(() => {
    if (showTree && treeData && treeRef.current) {
      const el = treeRef.current;
      setTimeout(() => {
        el.scrollTo({
          left: el.scrollWidth / 2 - el.clientWidth / 2,
          top: 0,
          behavior: "smooth",
        });
      }, 300);
    }
  }, [showTree]);

  // return (
  //   <div className="padding_15">
  //     <div className="row justify-content-center">
  //       <div className="col-12 col-md-12">
  //         <Card>
  //           <Card.Header>
  //             <h4 className="mb-0 text-center">My Family Tree</h4>
  //           </Card.Header>
  //           <Card.Body>
  //             <form onSubmit={fetchTreeData} className="mb-3">
  //               <div className="row g-2 justify-content-center">
  //                 <div className="col-12 col-md-4">
  //                   <input
  //                     type="text"
  //                     className="form-control form-control-sm"
  //                     placeholder="Mobile Number"
  //                     value={mobile}
  //                     onChange={(e) =>
  //                       setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
  //                     }
  //                   />
  //                 </div>
  //                 <div className="col-12 col-md-2">
  //                   <button
  //                     type="submit"
  //                     className="btn btn-primary btn-sm w-100"
  //                     disabled={loading}
  //                   >
  //                     {loading ? (
  //                       <Spinner animation="border" size="sm" />
  //                     ) : (
  //                       "Show"
  //                     )}
  //                   </button>
  //                 </div>
  //               </div>
  //             </form>

  //             {showTree && treeData && (
  //               <div className="tree-wrapper" ref={treeRef}>
  //                 <ul className="tree">{renderTree(treeData, true)}</ul>
  //               </div>
  //             )}
  //           </Card.Body>
  //         </Card>
  //       </div>
  //     </div>


  //   </div>
  // );
return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🌳
            </div>
            <div style={{ flex: 1 }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                My Family Tree
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                View your team hierarchy by mobile number
              </p>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px" }}>
              {/* 🎯 SEARCH FORM */}
              <form onSubmit={fetchTreeData} style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    value={mobile}
                    onChange={(e) =>
                      setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
                    }
                    style={{
                      flex: 1,
                      minWidth: "220px",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      outline: "none",
                      fontSize: "14px",
                    }}
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      padding: "12px 32px",
                      borderRadius: "10px",
                      border: "none",
                      background: loading
                        ? "#cbd5e1"
                        : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontSize: "14px",
                      fontWeight: "700",
                      cursor: loading ? "not-allowed" : "pointer",
                      boxShadow: loading
                        ? "none"
                        : "0 8px 24px rgba(30, 87, 153, 0.3)",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      minWidth: "120px",
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          style={{
                            width: "14px",
                            height: "14px",
                            border: "2px solid rgba(255,255,255,0.3)",
                            borderTop: "2px solid #ffffff",
                            borderRadius: "50%",
                            display: "inline-block",
                            animation: "spin 0.8s linear infinite",
                          }}
                        />
                        Loading...
                      </>
                    ) : (
                      "Show Tree"
                    )}
                  </button>
                </div>
              </form>

              {/* 🎯 TREE */}
              {showTree && treeData && (
                <div
                  ref={treeRef}
                  className="tree-wrapper"
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "70vh",
                    padding: "20px",
                    background: "#f8fafc",
                    borderRadius: "14px",
                    border: "1.5px dashed #e2e8f0",
                  }}
                >
                  <ul className="tree">{renderTree(treeData, true)}</ul>
                </div>
              )}

              {/* Empty state */}
              {!showTree && !loading && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "60px 20px",
                    color: "#94a3b8",
                  }}
                >
                  <div style={{ fontSize: "56px", marginBottom: "12px" }}>
                    🌳
                  </div>
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      color: "#64748b",
                      margin: 0,
                    }}
                  >
                    Enter a mobile number above to view the team tree
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* 🎯 TREE CSS (important — tree ke liye zaroori hai) */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .tree-wrapper {
          font-family: 'Poppins', 'DM Sans', sans-serif;
        }

        .tree,
        .tree ul {
          list-style: none;
          margin: 0;
          padding: 0;
          position: relative;
        }

        .tree ul {
          padding-left: 24px;
          margin-left: 12px;
          border-left: 2px dashed #cbd5e1;
        }

        .tree li {
          position: relative;
          margin: 12px 0;
          padding: 0;
        }

        .tree li > span {
          display: inline-block;
          background: #ffffff;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          padding: 12px 16px;
          font-size: 13px;
          color: #1e3a5f;
          box-shadow: 0 4px 12px rgba(30, 87, 153, 0.06);
          transition: all 0.2s ease;
          position: relative;
          min-width: 200px;
        }

        .tree li > span:hover {
          border-color: #2b6cb0;
          box-shadow: 0 8px 20px rgba(30, 87, 153, 0.15);
          transform: translateY(-2px);
        }

        .tree li > span strong {
          color: #1e5799;
          font-size: 14px;
          font-weight: 700;
        }

        .tree li > span small {
          color: #64748b;
          font-size: 11.5px;
          font-weight: 500;
        }

        .toggle-btn {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          border: none;
          background: linear-gradient(135deg, #1e5799, #2b6cb0);
          color: #ffffff;
          font-size: 14px;
          font-weight: 800;
          line-height: 1;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 10px rgba(30, 87, 153, 0.25);
          transition: transform 0.2s ease;
        }

        .toggle-btn:hover {
          transform: scale(1.1);
        }
      `}</style>
    </>
  );

}

export default MyTeamTree;